import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SendEmailService } from 'src/app/services/send-email.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {

  contactForm!: FormGroup;
  mapUrl!: SafeResourceUrl;
  emailSent = false;
  emailError = false;

  constructor(
    private fb: FormBuilder,
    private sanitizer: DomSanitizer,
    private sendEmailService: SendEmailService
  ) {}

  ngOnInit(): void {
    this.initializeForm();
    this.initializeMap();
  }

  private initializeForm(): void {
    this.contactForm = this.fb.group({
      fullName: [
        '',
        [
          Validators.required,
          Validators.minLength(2)
        ]
      ],
      email: [
        '',
        [
          Validators.required,
          Validators.email
        ]
      ],
      phone: [
        '',
        Validators.required
      ],
      interest: [
        ''
      ],
      message: [
        '',
        [
          Validators.required,
          Validators.minLength(5)
        ]
      ]
    });
  }

  private initializeMap(): void {
    const googleMapUrl =
      'https://www.google.com/maps?q=Bangsar+South,+Kuala+Lumpur&output=embed';
    this.mapUrl =
      this.sanitizer.bypassSecurityTrustResourceUrl(
        googleMapUrl
      );
  }

  onSubmit(): void {
    console.log('SUBMIT BUTTON CLICKED');
    this.emailSent = false;
    this.emailError = false;
  
    if (this.contactForm.invalid) {
      this.contactForm.markAllAsTouched();
      return;
    }
    const form = this.contactForm.value;
  
    const request = {
      name: form.fullName,
      ownerEmail: 'rohitsharma2605555@gmail.com',
      email: form.email,
      message:
        `Phone: ${form.phone}\n` +
        `Interest: ${form.interest || 'Not specified'}\n\n` +
        `Query:\n${form.message}`
    };
    this.sendEmailService.sendEmail(request).subscribe({
      next: (response) => {
        console.log('Email sent successfully:', response);
        // Show success message
        this.emailSent = true;
        // Reset form
        this.contactForm.reset();
        // Automatically hide message after 5 seconds
        setTimeout(() => {
          this.emailSent = false;
        }, 5000);
      },
      error: (error) => {
        console.error('Error sending email:', error);
        this.emailError = true;
        setTimeout(() => {
          this.emailError = false;
        }, 5000);
      }
    });
  }
}